export function safeParseStringArray(value: string | string[] | null | undefined): string[] {
  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value === 'string') {
    if (value.trim() === '') {
      return [];
    }

    // Try JSON parsing
    try {
      const parsed: unknown = JSON.parse(value);
      if (Array.isArray(parsed) && parsed.every(item => typeof item === 'string')) {
        return parsed;
      }
    } catch (error) {
      console.error('Error parsing string array:', error);
    }
  }

  return [];
}

export function safeJsonParse<T = unknown>(json: string): T | string | null {
  if (typeof json !== 'string') {
    return json as T;
  }

  const trimmed = json.trim();
  if (!trimmed) {
    return null;
  }

  const first = trimmed[0];

  if (first === '[' || first === '{' || first === '"') {
    try {
      return JSON.parse(trimmed) as T;
    } catch {
      console.error('Error parsing JSON:', trimmed);
      return null;
    }
  }

  const num = Number(trimmed);
  if (!Number.isNaN(num)) {
    return num as unknown as T;
  }

  // 3) Fallback: treat as a plain string
  return trimmed as unknown as T;
}
